import styled from 'styled-components/macro';

const InputStyled = styled.div`
  position: relative;

  &::after {
    content: '₽';
    position: absolute;
    top: 10px;
    right: 0;
  }
`;

export default InputStyled;
